const compareDates = (dateFirst, dateSecond) => {
  dateFirst.setHours(0, 0, 0, 0);
  dateSecond.setHours(0, 0, 0, 0);
  if (dateFirst.getTime() === dateSecond.getTime()) {
    return 0;
  }
  if (dateFirst < dateSecond) {
    return -1;
  }
  if (dateFirst > dateSecond) {
    return 1;
  }
};
export default compareDates;
